const Footer = () => (
  <footer className="bg-[#0d2b66] text-white text-center p-6 text-sm">
    Independencia 650, G4200 Santiago del Estero. clubquimsa@gmail.com
  </footer>
);

export default Footer;
